import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getCrmMemberMessages(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.SupportApi.getCrmMemberMessages, domainData.t, domainData.c, domainData.s, domainData.hi, memberId, params.startDate, params.endDate, params.hpSourceSystem); //t = access token, c = correlation id, s = session id
            logAPI("MBHWeb.Saga.HealthPlanServices.Support.GetCrmMemberMessages.Get", start, null);
            yield put({ type: types.HP_GET_CRM_MEMBER_MESSAGES_SUCCESS, crmMessages: response });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.GetCrmMemberMessages.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_CRM_MEMBER_MESSAGES_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.GetCrmMemberMessages.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* sendCrmMessage(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.SupportApi.sendCrmMessage, domainData.t, domainData.c, domainData.s, domainData.hi, memberId, params.msgType, params.msgDesc, params.fileName, params.attachment, params.caseid, params.title, params.mimetype, params.hpSourceSystem); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Support.SendCrmMessage.Send", start, null);
            yield put({ type: types.HP_SEND_CRM_MESSAGE_SUCCESS, isFetching: false, crmMessages: response });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.SendCrmMessage.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_SEND_CRM_MESSAGE_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.SendCrmMessage.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* createCrmTicket(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.SupportApi.createCrmTicket, domainData.t, domainData.c, domainData.s, domainData.hi, memberId, params.msgType, params.msgDesc, params.fileName, params.attachment, params.title, params.mimetype, params.hpSourceSystem); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Support.CreateCrmTicket.Send", start, null);
            yield put({ type: types.HP_CREATE_CRM_TICKET_SUCCESS, isFetching: false, crmSendMessageResponse: response });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.CreateCrmTicket.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_CREATE_CRM_TICKET_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Support.CreateCrmTicket.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}